import React from "react";

function Error() {
  return <div>Oooops....Ha ocurrido un error</div>;
}

export default Error;
